import { css } from "@emotion/react";
import { color } from "@moneyforward/mfx_biz_react_components";

type Props = {
  height?: number;
  width?: string | number;
};

export const Divider: React.FC<Props> = ({ height, width }: Props) => {
  if (!height) height = 1;
  if (!width) width = "100%";
  return <hr css={style(height, width)} />;
};

const style = (height: number, width: string | number) =>
  css({
    backgroundColor: color.gray300,
    height: height,
    width: width,
  });
